import React, { useState, useEffect } from 'react';
import { getTiposSocia } from '../services/tiposSociaService';
import profesionService from '../services/profesionService';
import mentorService from '../services/mentorService';
import locationService from '../services/locationService';
import { useNavigate } from 'react-router-dom';
import '../styles/RegisterPartner.css';
import { sociasStore } from '../services/sociasStore';
import { usersService } from '../services/usersService';
import sociasApiService from '../services/sociasApiService';


const RegisterPartner = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        // Datos personales
        cedula: '', tipoSocio: '', apellidos: '', nombres: '', fechaNacimiento: '', edad: '', sexo: '', profesion: '', nacionalidad: '', estadoCivil: '', foto: null,
        // Ubicación
        pais: '', ciudadDistrito: '', sectorBarrio: '', provinciaRegion: '', correoElectronico: '', telefono1: '', telefono2: '', direccion: '',
        // Redes sociales
        facebook: '', instagram: '', twitter: '',
        // Médicos
        tipoSindrome: '', discapacidad: '', tipoDiscapacidad: '', iess: '', talla: '', ministerioSalud: '', estado: '', fechaInscripcion: '', cariotipo: '', porcentaje: '', grado: '', edadDeteccion: '', hormonaCrecimiento: '', mentor: '',
        // Representante (solo si menor de edad)
        representanteCedula: '', representanteApellidos: '', representanteNombres: ''
    });
    const [fotoPreview, setFotoPreview] = useState(null);
    const [errors, setErrors] = useState({});
            // Estado para acordeón
            // Mostrar la primera sección abierta por defecto
            const [openSection, setOpenSection] = useState('personales');
    // Maneja la apertura/cierre de secciones del acordeón
    const handleAccordion = (section) => {
        setOpenSection(prev => prev === section ? null : section);
    };
    const [profesiones, setProfesiones] = useState([]);
    const [loadingProfesiones, setLoadingProfesiones] = useState(true);
    const [tiposSocio, setTiposSocio] = useState([]);
    const [loadingTiposSocio, setLoadingTiposSocio] = useState(true);
    const [mentores, setMentores] = useState([]);
    const [loadingMentores, setLoadingMentores] = useState(true);
    // Estados para ubicación
    const [paises, setPaises] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [loadingPaises, setLoadingPaises] = useState(true);
    const [selectedCountryCode, setSelectedCountryCode] = useState('');
    const ALL_GRADOS = ['Leve o ligera','Moderada','Grave','Muy grave o severa','Discapacidad completa'];
    const [allowedGrados, setAllowedGrados] = useState(ALL_GRADOS);

    const computeAllowedGrados = (percent) => {
        if (percent === '' || percent === null || percent === undefined) return ALL_GRADOS;
        const n = Number(percent);
        if (isNaN(n)) return ALL_GRADOS;
        if (n === 100) return ['Discapacidad completa'];
        if (n >= 75) return ['Muy grave o severa'];
        if (n >= 60) return ['Grave'];
        if (n >= 40) return ['Moderada'];
        if (n >= 0) return ['Leve o ligera'];
        return ALL_GRADOS;
    };

    useEffect(() => {
        const fetchTipos = async () => {
            try {
                const res = await getTiposSocia();
                setTiposSocio(res.data);
            } catch (err) {
                setTiposSocio([]);
            } finally {
                setLoadingTiposSocio(false);
            }
        };

        const fetchProfesiones = async () => {
            try {
                const profesionesData = await profesionService.getAllProfesiones();
                // Filtrar solo las profesiones activas
                const profesionesActivas = profesionesData.filter(prof => prof.PROFESION_ESTADO === 'Activo');
                setProfesiones(profesionesActivas);
            } catch (error) {
                console.error('Error al cargar profesiones:', error);
                setProfesiones([]);
            } finally {
                setLoadingProfesiones(false);
            }
        };

        const fetchMentores = async () => {
            try {
                const response = await mentorService.getAllMentores();
                // La API devuelve { success: true, data: [...] }
                const mentoresData = response.data || response;
                console.log('Mentores cargados:', mentoresData); // Debug
                // Filtrar solo mentores activos
                const mentoresActivos = Array.isArray(mentoresData) 
                    ? mentoresData.filter(mentor => mentor.mentorEstado === 'Activo')
                    : [];
                setMentores(mentoresActivos);
            } catch (error) {
                console.error('Error al cargar mentores:', error);
                setMentores([]);
            } finally {
                setLoadingMentores(false);
            }
        };

        fetchTipos();
        fetchProfesiones();
        fetchMentores();
        fetchPaises();
    }, []);

    // Cargar países
    const fetchPaises = async () => {
        try {
            setLoadingPaises(true);
            const data = await locationService.getCountries();
            setPaises(data);
        } catch (error) {
            console.error('Error al cargar países:', error);
            setPaises([]);
        } finally {
            setLoadingPaises(false);
        }
    };

    // Manejar cambio de país
    const handlePaisChange = async (e) => {
        const paisNombre = e.target.value;
        const paisSeleccionado = paises.find(p => p.name === paisNombre);
        
        setFormData(prev => ({
            ...prev,
            pais: paisNombre,
            provinciaRegion: '',
            ciudadDistrito: ''
        }));
        
        setProvincias([]);
        setCiudades([]);
        
        if (paisSeleccionado) {
            setSelectedCountryCode(paisSeleccionado.isoCode);
            try {
                const data = await locationService.getStates(paisSeleccionado.isoCode);
                setProvincias(data);
            } catch (error) {
                console.error('Error al cargar provincias:', error);
                setProvincias([]);
            }
        }
        
        if (errors.pais) setErrors(prev => ({ ...prev, pais: '' }));
    };

    // Manejar cambio de provincia
    const handleProvinciaChange = async (e) => {
        const provinciaNombre = e.target.value;
        const provinciaSeleccionada = provincias.find(p => p.name === provinciaNombre);
        
        setFormData(prev => ({
            ...prev,
            provinciaRegion: provinciaNombre,
            ciudadDistrito: ''
        }));
        
        setCiudades([]);
        
        if (provinciaSeleccionada && selectedCountryCode) {
            try {
                const data = await locationService.getCities(selectedCountryCode, provinciaSeleccionada.isoCode);
                setCiudades(data);
            } catch (error) {
                console.error('Error al cargar ciudades:', error);
                setCiudades([]);
            }
        }
        
        if (errors.provinciaRegion) setErrors(prev => ({ ...prev, provinciaRegion: '' }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Normalización específica para porcentaje: 0,6/0.6 => 60; rango 0-100
        if (name === 'porcentaje') {
            const raw = (value ?? '').toString().replace(',', '.').trim();
            if (raw === '') {
                setFormData(prev => ({ ...prev, porcentaje: '' }));
                setAllowedGrados(ALL_GRADOS);
            } else {
                const num = Number(raw);
                if (isNaN(num)) return;
                let normalized = num;
                if (num > 0 && num <= 1) normalized = num * 100;
                if (normalized < 0) normalized = 0;
                if (normalized > 100) normalized = 100;
                const asString = Number.isInteger(normalized) ? String(normalized) : String(parseFloat(normalized.toFixed(2)));
                setFormData(prev => ({ ...prev, porcentaje: asString }));
                const allowed = computeAllowedGrados(normalized);
                setAllowedGrados(allowed);
                // Si el grado actual no es permitido, ajustar
                setFormData(prev => {
                    if (prev.grado && !allowed.includes(prev.grado)) {
                        return { ...prev, grado: allowed[0] || '' };
                    }
                    return prev;
                });
            }
            if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
            return;
        }
        let newFormData = { ...formData, [name]: value };
        // Si cambia la fecha de nacimiento, calcular edad
        if (name === 'fechaNacimiento' && value) {
            const today = new Date();
            const birthDate = new Date(value);
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            newFormData.edad = age >= 0 ? String(age) : '';
        }
        setFormData(newFormData);
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleFotoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({ ...prev, foto: file }));
            const reader = new FileReader();
            reader.onloadend = () => setFotoPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const validateForm = () => {
        const newErrors = {};
        // Validar todos los campos requeridos
        const requiredFields = [
            // Personales
            'cedula','tipoSocio','apellidos','nombres','fechaNacimiento','edad','sexo','profesion','nacionalidad','estadoCivil','foto',
            // Ubicación
            'pais','ciudadDistrito','sectorBarrio','provinciaRegion','correoElectronico','telefono1','direccion',
            // Médicos
            'tipoSindrome','discapacidad','tipoDiscapacidad','ministerioSalud','estado','fechaInscripcion','cariotipo','porcentaje','grado','iess','edadDeteccion'
        ];
        requiredFields.forEach(field => { if (!formData[field]) newErrors[field] = 'Este campo es requerido'; });
        // Si es menor de edad, validar datos de representante
        if (parseInt(formData.edad, 10) < 18) {
            ['representanteCedula','representanteApellidos','representanteNombres'].forEach(field => {
                if (!formData[field]) newErrors[field] = 'Este campo es requerido';
            });
        }
        // Validaciones específicas
        if (formData.correoElectronico && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.correoElectronico)) newErrors.correoElectronico = 'Ingrese un correo electrónico válido';
        const phoneRegex = /^[\d-]+$/;
        if (formData.telefono1 && !phoneRegex.test(formData.telefono1)) newErrors.telefono1 = 'Ingrese un número de teléfono válido';
        if (formData.telefono2 && formData.telefono2.length > 0 && !phoneRegex.test(formData.telefono2)) newErrors.telefono2 = 'Ingrese un número de teléfono válido';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            // Crear FormData para enviar al backend
            const formDataToSend = new FormData();
            
            // Mapear campos del formulario a los nombres esperados por el backend
            formDataToSend.append('sociaApellido', formData.apellidos);
            formDataToSend.append('sociaNombre', formData.nombres);
            formDataToSend.append('sociaCedula', formData.cedula);
            formDataToSend.append('sociaFechaNacimiento', formData.fechaNacimiento);
            formDataToSend.append('sociaEdad', formData.edad);
            formDataToSend.append('sociaSexo', formData.sexo);
            formDataToSend.append('sociaNacionalidad', formData.nacionalidad);
            formDataToSend.append('sociaEstadoCivil', formData.estadoCivil);
            formDataToSend.append('tipoSociaId', formData.tipoSocio);
            formDataToSend.append('profesionId', formData.profesion);
            
            // Ubicación
            formDataToSend.append('sociaPais', formData.pais);
            formDataToSend.append('sociaProvincia', formData.provinciaRegion);
            formDataToSend.append('sociaCiudad', formData.ciudadDistrito);
            formDataToSend.append('sociaSector', formData.sectorBarrio);
            formDataToSend.append('sociaDireccion', formData.direccion);
            formDataToSend.append('sociaEmail', formData.correoElectronico);
            formDataToSend.append('sociaTelefono1', formData.telefono1);
            formDataToSend.append('sociaTelefono2', formData.telefono2 || '');
            
            // Redes sociales
            formDataToSend.append('sociaRfacebook', formData.facebook || '');
            formDataToSend.append('sociaRinstagram', formData.instagram || '');
            formDataToSend.append('sociaRx', formData.twitter || '');
            
            // Datos médicos
            formDataToSend.append('sociaTipoSindrome', formData.tipoSindrome || '');
            formDataToSend.append('sociaCariotipo', formData.cariotipo || '');
            formDataToSend.append('sociaCarnetDiscapacidad', formData.discapacidad === 'Si' ? 1 : 0);
            formDataToSend.append('sociaTipoDiscapacidad', formData.tipoDiscapacidad || '');
            // Normalizar porcentaje: acepta 0-1 como fracción o 0-100 como porcentaje
            (function(){
                const raw = (formData.porcentaje ?? '').toString().replace(',', '.').trim();
                let normalizedToSend = 0;
                if (raw !== '' && !isNaN(Number(raw))) {
                    let num = Number(raw);
                    if (num > 0 && num <= 1) num = num * 100;
                    if (num < 0) num = 0;
                    if (num > 100) num = 100;
                    normalizedToSend = Number.isInteger(num) ? num : parseFloat(num.toFixed(2));
                }
                formDataToSend.append('sociaPorcentajeDiscapacidad', String(normalizedToSend));
            })();
            // Validación: grado permitido por porcentaje
            const allowedBeforeSend = computeAllowedGrados(formData.porcentaje);
            if (formData.grado && !allowedBeforeSend.includes(formData.grado)) {
                setErrors(prev => ({ ...prev, grado: 'El grado no corresponde al porcentaje ingresado' }));
                return;
            }
            formDataToSend.append('sociaGrado', formData.grado || '');
            formDataToSend.append('sociaIees', formData.iess === 'Si' ? 1 : 0);
            formDataToSend.append('sociaEdadDeteccion', formData.edadDeteccion || 0);
            formDataToSend.append('sociaHormonaCrecimiento', formData.hormonaCrecimiento === 'Si' ? 1 : 0);
            formDataToSend.append('sociaMsp', formData.ministerioSalud === 'Si' ? 1 : 0);
            formDataToSend.append('sociaEstado', formData.estado);
            formDataToSend.append('sociaFechaInscripcion', formData.fechaInscripcion);
            
            // Representante
            formDataToSend.append('sociaRepresentante', parseInt(formData.edad) < 18 ? 1 : 0);
            formDataToSend.append('sociaRepresentanteCedula', formData.representanteCedula || '');
            formDataToSend.append('sociaRepresentanteNombre', 
                formData.representanteNombres && formData.representanteApellidos 
                    ? `${formData.representanteApellidos} ${formData.representanteNombres}` 
                    : ''
            );
            
            // Mentor (si no se selecciona, se guarda como "No asignado")
            formDataToSend.append('mentorId', formData.mentor || 'No asignado');
            
            // Foto
            if (formData.foto) {
                formDataToSend.append('sociaFoto', formData.foto);
            }

            // Enviar al backend
            const response = await sociasApiService.createSocia(formDataToSend);
            
            // Si la API responde correctamente, también guardar en store local como fallback
            const nueva = sociasStore.add(formData);
            
            // Sincronizar vista de usuario
            try {
                const tiposRes = await getTiposSocia();
                const tiposArr = Array.isArray(tiposRes?.data) ? tiposRes.data : [];
                const tiposById = tiposArr.reduce((acc, t) => { acc[t.TS] = t; return acc; }, {});
                usersService.syncFromSocia(nueva, tiposById);
            } catch {
                usersService.syncFromSocia(nueva, {});
            }
            
            alert('¡Socia creada exitosamente!');
            navigate('/register-partner/summary', { state: { partnerCode: response.SOCIA_ID || nueva.id } });
            
        } catch (error) {
            console.error('Error al crear socia:', error);
            console.error('Error response:', error.response?.data);
            const errorMsg = error.response?.data?.error || error.message || 'Error desconocido';
            alert('Error al crear socia: ' + errorMsg);
        }
    };

    const handleCancel = () => { navigate(-1); };

    return (
        <div className="register-partner-container">
            <form onSubmit={handleSubmit} className="register-partner-form">
                {/* Sección Datos Personales */}
                <div className="accordion-section">
                    <div
                        className={`accordion-header${openSection==='personales' ? ' active' : ''}`}
                        onClick={() => handleAccordion('personales')}
                    >
                        <span>Datos Personales</span>
                        <span className="accordion-chevron">▶</span>
                    </div>
                    {openSection==='personales' && (
                        <div className="accordion-content">
                            {/* ...campos personales... */}
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Cédula (*)</label>
                                    <input type="text" name="cedula" value={formData.cedula} onChange={handleInputChange} className={errors.cedula ? 'error' : ''} />
                                    {errors.cedula && <span className="error-message">{errors.cedula}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Tipo de socio (*)</label>
                                    <select name="tipoSocio" value={formData.tipoSocio} onChange={handleInputChange} className={errors.tipoSocio ? 'error' : ''}>
                                        <option value="">Seleccione un tipo...</option>
                                        {loadingTiposSocio ? (
                                            <option disabled>Cargando tipos...</option>
                                        ) : (
                                            tiposSocio.map(tipo => (
                                                <option key={tipo.TS} value={tipo.TS}>{tipo.TIPOSOCIA_NOMBRE}</option>
                                            ))
                                        )}
                                    </select>
                                    {errors.tipoSocio && <span className="error-message">{errors.tipoSocio}</span>}
                                </div>
                            </div>

                            {/* ...campos personales existentes... */}
                        {/* Sección de representante si menor de edad (al final de datos personales) */}
                        {parseInt(formData.edad, 10) < 18 && (
                            <div style={{ border: '1px solid #e0e0e0', borderRadius: 8, padding: 16, marginTop: 16, background: '#fafafa' }}>
                                <div style={{ width: '100%', marginBottom: 8, fontWeight: 'bold', color: '#b2004c' }}>Datos de representante</div>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Cédula representante (*)</label>
                                        <input type="text" name="representanteCedula" value={formData.representanteCedula} onChange={handleInputChange} className={errors.representanteCedula ? 'error' : ''} />
                                        {errors.representanteCedula && <span className="error-message">{errors.representanteCedula}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label>Apellidos representante (*)</label>
                                        <input type="text" name="representanteApellidos" value={formData.representanteApellidos} onChange={handleInputChange} className={errors.representanteApellidos ? 'error' : ''} />
                                        {errors.representanteApellidos && <span className="error-message">{errors.representanteApellidos}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label>Nombres representante (*)</label>
                                        <input type="text" name="representanteNombres" value={formData.representanteNombres} onChange={handleInputChange} className={errors.representanteNombres ? 'error' : ''} />
                                        {errors.representanteNombres && <span className="error-message">{errors.representanteNombres}</span>}
                                    </div>
                                </div>
                            </div>
                        )}
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Apellidos (*)</label>
                                    <input type="text" name="apellidos" value={formData.apellidos} onChange={handleInputChange} className={errors.apellidos ? 'error' : ''} />
                                    {errors.apellidos && <span className="error-message">{errors.apellidos}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Nombres (*)</label>
                                    <input type="text" name="nombres" value={formData.nombres} onChange={handleInputChange} className={errors.nombres ? 'error' : ''} />
                                    {errors.nombres && <span className="error-message">{errors.nombres}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Fecha de nacimiento (*)</label>
                                    <input type="date" name="fechaNacimiento" value={formData.fechaNacimiento} onChange={handleInputChange} className={errors.fechaNacimiento ? 'error' : ''} />
                                    {errors.fechaNacimiento && <span className="error-message">{errors.fechaNacimiento}</span>}
                                </div>
                                <div className="form-group">
                                    <label>EDAD (*)</label>
                                    <input type="number" name="edad" value={formData.edad} readOnly className={errors.edad ? 'error' : ''} />
                                    {errors.edad && <span className="error-message">{errors.edad}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Sexo (*)</label>
                                    <select name="sexo" value={formData.sexo} onChange={handleInputChange} className={errors.sexo ? 'error' : ''}>
                                        <option value="">Seleccione...</option>
                                        <option value="F">Femenino</option>
                                        <option value="M">Masculino</option>
                                    </select>
                                    {errors.sexo && <span className="error-message">{errors.sexo}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Profesión (*)</label>
                                    <select name="profesion" value={formData.profesion} onChange={handleInputChange} className={errors.profesion ? 'error' : ''} disabled={loadingProfesiones}>
                                        <option value="">Seleccione una profesión...</option>
                                        {profesiones.map(prof => (
                                            <option key={prof.PROFESION_ID} value={prof.PROFESION_ID}>
                                                {prof.PROFESION_NOMBRE}
                                            </option>
                                        ))}
                                    </select>
                                    {loadingProfesiones && <span className="loading-message">Cargando profesiones...</span>}
                                    {errors.profesion && <span className="error-message">{errors.profesion}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Nacionalidad (*)</label>
                                    <input type="text" name="nacionalidad" value={formData.nacionalidad} onChange={handleInputChange} className={errors.nacionalidad ? 'error' : ''} />
                                    {errors.nacionalidad && <span className="error-message">{errors.nacionalidad}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Estado Civil (*)</label>
                                    <select name="estadoCivil" value={formData.estadoCivil} onChange={handleInputChange} className={errors.estadoCivil ? 'error' : ''}>
                                        <option value="">Seleccione...</option>
                                        <option value="Soltero/a">Soltero/a</option>
                                        <option value="Casado/a">Casado/a</option>
                                        <option value="Divorciado/a">Divorciado/a</option>
                                        <option value="Viudo/a">Viudo/a</option>
                                    </select>
                                    {errors.estadoCivil && <span className="error-message">{errors.estadoCivil}</span>}
                                </div>
                            </div>
                            <div className="form-row photo-section">
                                <div className="form-group">
                                    <label>FOTO (*)</label>
                                    <div className="photo-upload-container">
                                        <div className="photo-preview">
                                            {fotoPreview ? (<img src={fotoPreview} alt="Vista previa" />) : (<div className="photo-placeholder"><p>Subir Fotografía tamaño carnet</p></div>)}
                                        </div>
                                        <input type="file" name="foto" onChange={handleFotoChange} accept="image/*" className={errors.foto ? 'error' : ''} />
                                        {errors.foto && <span className="error-message">{errors.foto}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {/* Sección Ubicación */}
                <div className="accordion-section">
                    <div
                        className={`accordion-header${openSection==='ubicacion' ? ' active' : ''}`}
                        onClick={() => handleAccordion('ubicacion')}
                    >
                        <span>Datos de Ubicación</span>
                        <span className="accordion-chevron">▶</span>
                    </div>
                    {openSection==='ubicacion' && (
                        <div className="accordion-content">
                            <div className="form-row">
                                <div className="form-group">
                                    <label>País (*)</label>
                                    <select 
                                        name="pais" 
                                        value={formData.pais} 
                                        onChange={handlePaisChange} 
                                        className={errors.pais ? 'error' : ''} 
                                        disabled={loadingPaises}
                                    >
                                        <option value="">{loadingPaises ? 'Cargando países...' : 'Seleccione un país...'}</option>
                                        {paises.map(pais => (
                                            <option key={pais.isoCode} value={pais.name}>
                                                {pais.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.pais && <span className="error-message">{errors.pais}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Provincia/Región (*)</label>
                                    <select 
                                        name="provinciaRegion" 
                                        value={formData.provinciaRegion} 
                                        onChange={handleProvinciaChange} 
                                        className={errors.provinciaRegion ? 'error' : ''} 
                                        disabled={!formData.pais || provincias.length === 0}
                                    >
                                        <option value="">{!formData.pais ? 'Seleccione un país primero' : 'Seleccione una provincia...'}</option>
                                        {provincias.map(provincia => (
                                            <option key={provincia.isoCode} value={provincia.name}>
                                                {provincia.name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.provinciaRegion && <span className="error-message">{errors.provinciaRegion}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Ciudad/Distrito (*)</label>
                                    <select 
                                        name="ciudadDistrito" 
                                        value={formData.ciudadDistrito} 
                                        onChange={handleInputChange} 
                                        className={errors.ciudadDistrito ? 'error' : ''} 
                                        disabled={!formData.provinciaRegion || ciudades.length === 0}
                                    >
                                        <option value="">{!formData.provinciaRegion ? 'Seleccione una provincia primero' : 'Seleccione una ciudad...'}</option>
                                        {ciudades.map((ciudad, index) => (
                                            <option key={index} value={ciudad}>
                                                {ciudad}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.ciudadDistrito && <span className="error-message">{errors.ciudadDistrito}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Sector/Barrio (*)</label>
                                    <input type="text" name="sectorBarrio" value={formData.sectorBarrio} onChange={handleInputChange} className={errors.sectorBarrio ? 'error' : ''} />
                                    {errors.sectorBarrio && <span className="error-message">{errors.sectorBarrio}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Correo Electrónico (*)</label>
                                    <input type="email" name="correoElectronico" value={formData.correoElectronico} onChange={handleInputChange} className={errors.correoElectronico ? 'error' : ''} />
                                    {errors.correoElectronico && <span className="error-message">{errors.correoElectronico}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Teléfono 1 (*)</label>
                                    <input type="tel" name="telefono1" value={formData.telefono1} onChange={handleInputChange} className={errors.telefono1 ? 'error' : ''} placeholder="Ejemplo: 0999-999-999" />
                                    {errors.telefono1 && <span className="error-message">{errors.telefono1}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Teléfono 2</label>
                                    <input type="tel" name="telefono2" value={formData.telefono2} onChange={handleInputChange} className={errors.telefono2 ? 'error' : ''} placeholder="Ejemplo: 0999-999-999" />
                                    {errors.telefono2 && <span className="error-message">{errors.telefono2}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Dirección (*)</label>
                                    <input type="text" name="direccion" value={formData.direccion} onChange={handleInputChange} className={errors.direccion ? 'error' : ''} />
                                    {errors.direccion && <span className="error-message">{errors.direccion}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Facebook</label>
                                    <input type="text" name="facebook" value={formData.facebook} onChange={handleInputChange} placeholder="Usuario o enlace de Facebook" />
                                </div>
                                <div className="form-group">
                                    <label>Instagram</label>
                                    <input type="text" name="instagram" value={formData.instagram} onChange={handleInputChange} placeholder="Usuario o enlace de Instagram" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Twitter/X</label>
                                    <input type="text" name="twitter" value={formData.twitter} onChange={handleInputChange} placeholder="Usuario o enlace de Twitter/X" />
                                </div>
                                <div className="form-group">
                                    {/* Espacio vacío para mantener simetría */}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {/* Sección Médica */}
                <div className="accordion-section">
                    <div
                        className={`accordion-header${openSection==='medicos' ? ' active' : ''}`}
                        onClick={() => handleAccordion('medicos')}
                    >
                        <span>Datos Médicos</span>
                        <span className="accordion-chevron">▶</span>
                    </div>
                    {openSection==='medicos' && (
                        <div className="accordion-content">
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Fecha de inscripción (*)</label>
                                    <input type="date" name="fechaInscripcion" value={formData.fechaInscripcion} onChange={handleInputChange} className={errors.fechaInscripcion ? 'error' : ''} />
                                    {errors.fechaInscripcion && <span className="error-message">{errors.fechaInscripcion}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Tipo de Síndrome (*)</label>
                                    <select name="tipoSindrome" value={formData.tipoSindrome} onChange={handleInputChange} className={errors.tipoSindrome ? 'error' : ''}>
                                        <option value="">Seleccione un tipo...</option>
                                        <option value="Monosomía X completa (45,X)">Monosomía X completa (45,X)</option>
                                        <option value="Mosaicismo 45,X/46,XX">Mosaicismo 45,X/46,XX</option>
                                        <option value="Mosaicismo 45,X/47,XXX">Mosaicismo 45,X/47,XXX</option>
                                        <option value="Mosaicismo 45,X/46,XY">Mosaicismo 45,X/46,XY</option>
                                        <option value="Mosaicismo 45,X/46,X,i(Xq)">Mosaicismo 45,X/46,X,i(Xq)</option>
                                        <option value="Mosaicismo 45,X/46,X,r(X)">Mosaicismo 45,X/46,X,r(X)</option>
                                        <option value="Deleción del brazo corto del cromosoma">Deleción del brazo corto del cromosoma</option>
                                        <option value="Deleción del brazo largo del cromosoma">Deleción del brazo largo del cromosoma</option>
                                        <option value="Isochromosoma del brazo largo del X">Isochromosoma del brazo largo del X</option>
                                        <option value="Cromosoma en anillo del X">Cromosoma en anillo del X</option>
                                        <option value="Mosaicismo triple">Mosaicismo triple</option>
                                        <option value="Mosaicismo complejo">Mosaicismo complejo</option>
                                        <option value="Translocación entre dos cromosomas X">Translocación entre dos cromosomas X</option>
                                        <option value="Translocación entre X y un autosoma">Translocación entre X y un autosoma</option>
                                        <option value="Translocación entre X y Y">Translocación entre X y Y</option>
                                        <option value="Duplicación parcial del X">Duplicación parcial del X</option>
                                        <option value="Inversión del cromosoma">Inversión del cromosoma</option>
                                        <option value="Cromosoma X dicéntrico">Cromosoma X dicéntrico</option>
                                        <option value="Cromosoma en anillo derivado del Y">Cromosoma en anillo derivado del Y</option>
                                        <option value="Monosomía X parcial">Monosomía X parcial</option>
                                    </select>
                                    {errors.tipoSindrome && <span className="error-message">{errors.tipoSindrome}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Cariotipo (*)</label>
                                    <input type="text" name="cariotipo" value={formData.cariotipo} onChange={handleInputChange} className={errors.cariotipo ? 'error' : ''} />
                                    {errors.cariotipo && <span className="error-message">{errors.cariotipo}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>¿Tiene carnet de discapacidad? (*)</label>
                                    <select name="discapacidad" value={formData.discapacidad} onChange={handleInputChange} className={errors.discapacidad ? 'error' : ''}>
                                        <option value="">Seleccione una opción...</option>
                                        <option value="Si">Si</option>
                                        <option value="No">No</option>
                                    </select>
                                    {errors.discapacidad && <span className="error-message">{errors.discapacidad}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Porcentaje de discapacidad (*)</label>
                                    <input type="number" name="porcentaje" value={formData.porcentaje} onChange={handleInputChange} min="0" max="100" step="0.01" className={errors.porcentaje ? 'error' : ''} />
                                    {errors.porcentaje && <span className="error-message">{errors.porcentaje}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Tipo de discapacidad (*)</label>
                                    <select name="tipoDiscapacidad" value={formData.tipoDiscapacidad} onChange={handleInputChange} className={errors.tipoDiscapacidad ? 'error' : ''}>
                                        <option value="">Seleccione un tipo...</option>
                                        <option value="Física">Física</option>
                                        <option value="Auditiva">Auditiva</option>
                                        <option value="Lenguaje">Lenguaje</option>
                                        <option value="Intelectual">Intelectual</option>
                                        <option value="Psicosocial">Psicosocial</option>
                                        <option value="Múltiple">Múltiple</option>
                                    </select>
                                    {errors.tipoDiscapacidad && <span className="error-message">{errors.tipoDiscapacidad}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Grado (*)</label>
                                    <select name="grado" value={formData.grado} onChange={handleInputChange} className={errors.grado ? 'error' : ''}>
                                        <option value="">Seleccione un grado...</option>
                                        {allowedGrados.map(g => (
                                            <option key={g} value={g}>{g}</option>
                                        ))}
                                    </select>
                                    {errors.grado && <span className="error-message">{errors.grado}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>IESS (*)</label>
                                    <select name="iess" value={formData.iess} onChange={handleInputChange} className={errors.iess ? 'error' : ''}>
                                        <option value="">Seleccione una opción...</option>
                                        <option value="Si">Si</option>
                                        <option value="No">No</option>
                                    </select>
                                    {errors.iess && <span className="error-message">{errors.iess}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Edad de detección (*)</label>
                                    <input type="text" name="edadDeteccion" value={formData.edadDeteccion} onChange={handleInputChange} className={errors.edadDeteccion ? 'error' : ''} />
                                    {errors.edadDeteccion && <span className="error-message">{errors.edadDeteccion}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Talla</label>
                                    <input type="text" name="talla" value={formData.talla} onChange={handleInputChange} className={errors.talla ? 'error' : ''} />
                                    {errors.talla && <span className="error-message">{errors.talla}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Hormona de crecimiento</label>
                                    <input type="text" name="hormonaCrecimiento" value={formData.hormonaCrecimiento} onChange={handleInputChange} className={errors.hormonaCrecimiento ? 'error' : ''} />
                                    {errors.hormonaCrecimiento && <span className="error-message">{errors.hormonaCrecimiento}</span>}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>Ministerio de salud (*)</label>
                                    <input type="text" name="ministerioSalud" value={formData.ministerioSalud} onChange={handleInputChange} className={errors.ministerioSalud ? 'error' : ''} />
                                    {errors.ministerioSalud && <span className="error-message">{errors.ministerioSalud}</span>}
                                </div>
                                <div className="form-group">
                                    <label>Mentor</label>
                                    <select name="mentor" value={formData.mentor} onChange={handleInputChange} className={errors.mentor ? 'error' : ''} disabled={loadingMentores}>
                                        <option value="">{loadingMentores ? 'Cargando mentores...' : 'Seleccione un mentor...'}</option>
                                        {mentores.map(m => (
                                            <option key={m.mentorId} value={m.mentorId}>
                                                {m.mentorNombre} {m.mentorSector ? `- ${m.mentorSector}` : ''}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.mentor && <span className="error-message">{errors.mentor}</span>}
                                </div>
                            </div>
                            <div className="form-row single-field">
                                <div className="form-group">
                                    <label>Estado (*)</label>
                                    <select name="estado" value={formData.estado} onChange={handleInputChange} className={errors.estado ? 'error' : ''}>
                                        <option value="">Seleccione un estado...</option>
                                        <option value="Activo">Activo</option>
                                        <option value="Inactivo">Inactivo</option>
                                    </select>
                                    {errors.estado && <span className="error-message">{errors.estado}</span>}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="form-actions">
                    <button type="button" onClick={handleCancel} className="cancel-button">Cancelar</button>
                    <button type="submit" className="create-button">CREAR SOCIA</button>
                </div>
            </form>
        </div>
    );
};

export default RegisterPartner;